import { useHead } from "@/lib/head";

interface NoIndexProps {
  title: string;
}

/** Pagine di servizio (login, area riservata, 404): titolo proprio e fuori dall'indice. */
const NoIndex = ({ title }: NoIndexProps) => {
  useHead("noindex", [
    { tag: "title", text: title },
    { tag: "meta", name: "robots", content: "noindex" },
  ]);
  return null;
};

export default NoIndex;
